import React, { useEffect, useState } from "react";
import CandidateForm from "../forms/candidateForm/CandidateInfoForm";
import UserForm from "../forms/UserInfoForm";
import OnBoarding from "../shared/onboarding/Onboarding";
import OldOnBoarding from "../shared/onboarding/oldOnboarding";
import { message } from "antd";
import axios from "axios";
import config from "../../config";
import useCheckIfLoggedIn from "../../hooks/useCheckIfLoggedIn";

// Safe localStorage helpers
const safeGetItem = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    console.warn(`localStorage.getItem failed for key="${key}"`, e);
    return null;
  }
};

const safeSetItem = (key, value) => {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (e) {
    console.warn(`localStorage.setItem failed for key="${key}"`, e);
    return false;
  }
};

const UserSignupFormServe = (props) => {
  useCheckIfLoggedIn();
  const [isAdvertiser, setIsAdvertiser] = useState(true);
  const [type, setType] = useState("");

  useEffect(() => {
    const typeProp = props.match.params.type;
    const role = safeGetItem("role"); // ✅ Safe access
    
    if (role === "advertiser") {
      setIsAdvertiser(true);
    } else if (role === "first-auth" && typeProp === "advertiser") {
      handleAdvertiser();
    }
    setType(typeProp);
  }, [props.match.params.type]); // eslint-disable-line

  const updateUserWithDefaultPlan = async () => {
    const accessToken = safeGetItem("access_token"); // ✅ Safe access
    
    await axios.patch(
      `${config.USERS}/users/plans`,
      {},
      {
        cors: true,
        timeout: 10000,
        headers: {
          token: accessToken,
          plan: "free",
        },
      }
    );
  };

  const handleAdvertiser = async () => {
    try {
      await updateUserWithDefaultPlan();
      await updateUserRole("advertiser");
      safeSetItem("role", "advertiser"); // ✅ Safe write
      setIsAdvertiser(true);
    } catch (err) {
      console.error(err);
      message.error("There was a problem connecting to the network.");
    }
    setIsAdvertiser(true);
    // props.history.push("/onboard");
  };

  const updateUserRole = async (role) => {
    const accessToken = safeGetItem("access_token"); // ✅ Safe access
    
    //ONBOARD CHANGE HERE
    const doc = JSON.stringify({
      role: role,
    });
    await axios.patch(
      `${config.USERS}/users`,
      {},
      {
        headers: {
          token: accessToken,
          doc: encodeURIComponent(doc),
        },
      }
    );
  };

  return (
    <div>
      {type === "candidate" ? <CandidateForm /> : null}
      {type === "user" ? <UserForm /> : null}
      {type === "old" ? <OldOnBoarding /> : null}
      {type === "advertiser" && isAdvertiser ? (
        <OnBoarding props={props} history={props.history} />
      ) : null}
    </div>
  );
};

export default UserSignupFormServe;